// extracted by mini-css-extract-plugin
export var container = "index-module--container--gXFwZ";
export var gradBorder = "index-module--gradBorder--rlKuM";
export var imageBox = "index-module--imageBox--2KOfZ";
export var investorLogo = "index-module--investorLogo--Rk2KE";
export var investorLogos = "index-module--investorLogos--zZ6Gl";
export var subtitle = "index-module--subtitle--PTDyD";
export var title = "index-module--title--ZDy-j";